import { StreamType } from '@wix/da-shared-react/pkg/Stream';
import { StreamInitConfig } from '@wix/da-shared-react/pkg/Stream/base/types';
import { fetchNextMyLibrary } from './redux/actions';

export const PREVIEW_BASE_URL =
  'https://st.deviantart.net/muro/brush_previews/';
export const CACHE_BUSTER = '2';

export const i18nNamespace = 'muro';

export type WhichMuro = 'micro' | 'mini' | 'mobile';

export const MURO_COMMENTS_FOLDER_NAME = 'Comments creations';
export const MURO_FILES_FOLDER_NAME = 'Drawings';

export const MIN_IMPORT_SIZE = 200;

export const MURO_LIBRARY_STREAM = {
  streamId: 'MURO_MY_LIBRARY_STREAM',
  streamConfig: {
    autoFetch: false,
    itemsPerFetch: 50,
    streamType: StreamType.WITH_OFFSET,
    fetchNextCallback: fetchNextMyLibrary,
  } as StreamInitConfig,
  papiEndpointUrl: '/gallection/contents',
};
